<script>
import axios from 'axios';
import ImageModal from '../../../components/01-global_components/Apps/components/ImageModal.vue';

export default {
  props: ['data'],
  components: {
    ImageModal,
  },
  methods: {
    openImageDialog() {
      const modal = this.$refs['image-dialog-modal']?.$el;

      if (modal) modal.showModal();
    },
    closeModal() {
      this.$emit('close');
    },
    getBase64(url) {
      this.downloadProgress = true;
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${url}.jpg`);
        document.body.appendChild(fileLink);

        fileLink.click();
        this.downloadProgress = false;
      });
    },
  },
  data: () => ({
    index: null,
    selectedImage: 0,
    downloadProgress: false,
  }),
  computed: {
    images: function () {
      const imageArr = this.data.map((item) => {
        const description = item.metaData.filter(
          (i) => i.Name === 'Beskrivning'
        );
        const image = {
          title: item.name,
          description:
            description && description[0] && description[0].Value
              ? description[0].Value
              : 'Ingen beskrivning',
          src: item.orgImageUrl,
          metaData: item.metaData,
        };
        return image;
      });
      return imageArr;
    },
  },
};
</script>

<template>
  <div>
    <div
      class="image-gallery-modal-container"
      :class="{ active: data }"
      v-if="data">
      <div class="container">
        <div class="image-gallery-modal" @click.stop>
          <div class="image-gallery-modal_header">
            <button title="Close" @click="closeModal" type="button">
              <i class="material-icons">close</i>
            </button>
          </div>

          <section
            class="image-gallery-modal_body row"
            v-if="images && images.length">
            <div class="image-gallery-modal_images col-12 col-md-5">
              <div
                class="image-selected"
                :style="{
                  backgroundImage: 'url(' + images[selectedImage].src + ')',
                }">
                <div class="image-selected_actions">
                  <button
                    title="zoom"
                    @click="openImageDialog()"
                    class="btn-small">
                    <i class="material-icons">search</i>
                  </button>
                  <button
                    title="download"
                    :disabled="downloadProgress"
                    :class="{ downloading: downloadProgress }"
                    @click="getBase64(images[selectedImage].src)"
                    class="btn-small">
                    <span class="material-icons" v-if="!downloadProgress"
                      >save</span
                    >
                    <span class="material-icons spin" v-else>loop</span>
                  </button>
                </div>
              </div>
              <div class="images" v-if="images && images.length > 1">
                <button
                  class="image"
                  v-for="(image, index) in images"
                  :key="index"
                  @click="selectedImage = index"
                  :class="{ active: selectedImage == index }"
                  :style="{
                    backgroundImage: 'url(' + image.src + ')',
                  }"></button>
              </div>
            </div>

            <div class="image-gallery-model_info col-12 col-md-7">
              <h3>{{ images[selectedImage].title }}</h3>
              <div
                v-for="(item, index) in images[selectedImage].metaData"
                :key="index">
                <strong v-if="item.Name == 'Tags'">Taggar</strong>
                <strong v-else>{{ item.Name }}</strong>
                <p>{{ item.Value }}</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <template v-if="data">
        <ImageModal
          ref="image-dialog-modal"
          :images="data"
          :selected-index="selectedImage" />
      </template>
    </div>
  </div>
</template>
